<template>
    <div class="flex flex-col h-full">
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">{{ item.full_name }}<small class="text-xs ml-2">Member</small></template>
        </page-header>

        <tabs :tabs="tabs" :active="startTab" @setTab="setActiveTab" ref="tabs"></tabs>

        <div class="flex xl:flex-row lg:flex-col md:flex-col sm:flex-col flex-grow">
            <div class="xl:w-3/4 lg:w-full md:w-full sm:w-full px-4 sm:px-6 lg:px-6 bg-white border-r border-gray-400 bg-gray-200">
                <div class="mt-2 grid grid-cols-12 row-gap-5 col-gap-4 sm:grid-cols-12" v-if="!loading" v-show="activeTab === 'details'">
                    <div class="sm:col-span-12">
                        <table class="w-full mb-4 internal-table">
                            <thead>
                                <tr>
                                    <th colspan="2">Contact Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="w-40">Name</td>
                                    <td>{{ item.full_name }}</td>
                                </tr>
                                <tr v-if="item.other_first">
                                    <td class="w-40">Other Name <small v-if="item.other_name_preferred">(Preferred)</small></td>
                                    <td>{{ item.other_first+' '+item.other_last }}</td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td>{{ item.email }}</td>
                                </tr>
                                <tr>
                                    <td>Mobile</td>
                                    <td>{{ item.mobile }}</td>
                                </tr>
                                <tr>
                                    <td>Address</td>
                                    <td>{{ item.address }} {{ item.suburb }} {{ item.state }} {{ item.postcode }}</td>
                                </tr>
                                <tr v-if="item.postal_address">
                                    <td>Postal Address</td>
                                    <td>{{ item.postal_address }} {{ item.postal_suburb }} {{ item.postal_state }} {{ item.postal_postcode }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="mt-1 grid grid-cols-1 row-gap-2 col-gap-4 sm:grid-cols-12" v-if="!loading" v-show="activeTab === 'applications'">

                </div>
                <div class="mt-1 grid grid-cols-1 row-gap-2 col-gap-4 sm:grid-cols-12" v-if="!loading" v-show="activeTab === 'associates'">

                </div>
                <div class="mt-1 grid grid-cols-1 row-gap-2 col-gap-4 sm:grid-cols-12" v-if="!loading" v-show="activeTab === 'logs'">

                </div>
                <notes v-if="!loading"
                    v-show="activeTab === 'notes'"
                    :id="item.id"
                    :notes="item.notes"
                    model="Member" />
            </div>
            <div class="xl:w-1/4 lg:w-full md:w-full sm:w-full px-4 sm:px-6 lg:px-6">
                <div class="mt-2 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12" v-if="!loading">
                    <div class="sm:col-span-12">
                        <table class="w-full mb-6 internal-table">
                            <thead>
                            <tr>
                                <th colspan="2">Meta</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Last Updated</td>
                                    <td>{{ new Date(item.meta.updated_at) | moment("DD/MM/YYYY h:mm a") }}</td>
                                </tr>
                                <tr>
                                    <td>Created At</td>
                                    <td>{{ new Date(item.meta.created_at) | moment("DD/MM/YYYY h:mm a") }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as router from "vue-router";
    import Tabs from "../../mixins/Tabs";
    import axios from "axios";
    import Notes from "@/components/Notes";

    export default {
        name: "MemberView",
        props: {
            id: { required: true },
            return: { required: false, default: '/members' },
            page: { required: false, default: 'members' }
        },
        components: {
            Notes
        },
        mixins: [
            Tabs
        ],
        data: function () {
            return {
                tabs: [
                    {
                        name: 'Details',
                        slug: 'details'
                    },
                    {
                        name: 'Applications',
                        slug: 'applications'
                    },
                    {
                        name: 'Associates',
                        slug: 'associates'
                    },
                    {
                        name: 'Notes',
                        slug: 'notes'
                    },
                ],
                startTab: null,
                loading: true,
                item: {},
                pageActions: {},
                companyFields: [
                    {
                        name: 'Trading Name',
                        column: 'trading_name',
                        route: '/companies/{id}/view',
                        linked: true,
                    },
                    {
                        name: 'Legal Name',
                        column: 'legal_name',
                    },
                    {
                        name: 'Website',
                        column: 'website',
                        linked: true,
                        external: 'website'
                    },
                    {
                        name: 'Phone',
                        column: 'phone',
                    }
                ],
                companyActions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'View', link: 'view', icon: 'eye', iconClass: 'text-blue-600',  type: 'router-link', tooltip: 'View', permissions: this.resource+'.show' },
                        { label: 'Edit', link: 'edit', icon: 'edit', iconClass: 'text-gray-400', type: 'router-link', tooltip: 'Edit', permissions: this.resource+'.edit' },
                        { label: 'Unlink', method: 'unlink', icon: 'unlink', iconClass: 'text-red-500', type: 'method', tooltip: 'Unlink', permissions: this.resource+'.edit' },
                    ]
                }
            }
        },
        methods: {
            getData: function(){
                this.$Progress.start();

                axios.get(process.env.VUE_APP_API_URL + '/members/'+this.id)
                .then(response => {
                    this.item = response.data;

                    this.pageActions = {
                        buttons: [
                            {
                                label: 'Edit',
                                icon: 'edit',
                                type: 'router-link',
                                link: '/members/'+ this.id + '/edit',
                                iconClass: 'text-gray-700',
                                display: !!(this.$store.getters.permissions.indexOf('members.edit') !== -1 || this.$store.getters.nimdarepus)
                            },
                            {
                                label: 'Close',
                                icon: 'times',
                                type: 'router-link',
                                iconClass: 'text-red-500',
                                link: this.return ? this.return : '/members',
                            },
                        ],
                        additional: [
                            {
                                label: 'Delete',
                                icon: 'trash-alt',
                                type: 'method',
                                method: 'deleteModal',
                                iconClass: 'text-red-500',
                                display: !!(this.$store.getters.permissions.indexOf('members.destroy') !== -1 || this.$store.getters.nimdarepus)
                            }
                        ]
                    };

                    this.$Progress.finish();
                    this.loading = false;
                })
                .catch(() => {
                    this.$Progress.finish();
                    this.loading = false;
                });
            },
            methodHandler: function (method) {
                this[method]();
            },
            actionHandler: function (data) {
                this[data.method](data);
            }
        },
        mounted() {
            this.getData();
        }
    }
</script>

<style scoped>

</style>
